import { createPinia, PiniaVuePlugin } from 'pinia';
import Vue from 'vue';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

Vue.use(PiniaVuePlugin);

export const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
